<div (onResize)="onResize()" class="p-table-container">
    <p-table #Table
		Infinite-Table
		[loading]="loading"
		(onInfiniteLoad)="onScrollPageReached()"
		(onScroll)="onScrollChanged($event)"
		[value]="notes"
		[rowHover]="!showVerticalView"
		[scrollable]="true"
		(onSort)="onSortChanged($event)"
		[multiSortMeta]="initSort"
		(sortFunction)="sortNotes($event)"
		[customSort]="true"
		[sortMode]="sortMode || ''"
		scrollHeight="flex"
		[showLoader]="pollBased"
		styleClass="p-datatable-sm  p-datatable-gridlines"
		[ngClass]="{'read-only-user': readOnlyUser, 'vertical-view': showVerticalView, 'p-datatable-striped': showVerticalView}">

        <ng-template pTemplate="caption">
			<lb-notes-table-caption
				[columnKeys]="columnKeys"
				[downloadCSV]="downloadCSV"
				[enableAutoScroll]="enableAutoScroll"
				[enableReportFiltering]="enableReportFiltering"
				[exportMessage]="exportMessage"
				[getPDFReportQueryParams]="getPDFReportQueryParams"
				[lastUpdate]="lastUpdate"
				[loading]="loading"
				[notesMessage]="notesMessage"
				[pollBased]="pollBased"
				[savedPreferencesKey]="savedPreferencesKey"
				[scrollTop]="scrollTop"
				[showMaximizeButton]="showMaximizeButton"
				[sortMode]="sortMode"
				[table]="table!"
				[turnoverTooltip]="turnoverTooltip"
				[turnoverFilter]="turnoverFilter"
				[useNoteActions]="useNoteActions"
				(cancelQueryClicked)="onCancelQueryClicked()"
				(columnToggled)="updateShownColumns()"
				(expandCollapseContentClicked)="onExpandCollapseContentClicked($event)"
				[(maximized)]="maximized"
				(reportFilterChanged)="onReportFilterChanged($event)"
				(refreshQueryClicked)="onRefreshQueryClicked()"
				(showDefaultColumnsClicked)="onShowDefaultColumnsClicked()"
				(turnoverFilterChanged)="onTurnoverFilterChanged($event)">
			</lb-notes-table-caption>
		</ng-template>
		
        <ng-template pTemplate="header">
            <tr>
				<th *ngIf="sortMode" pSortableColumn="timeframe" class="timeframe">
					<div class="p-d-flex p-ai-center">
						Timeframe
						<p-sortIcon field="timeframe" [pTooltip]="sortIconTooltips.timeframe"></p-sortIcon>

						<p-columnFilter #TimeframeFilter *ngIf="enableColumnFiltering" class="p-ml-auto" display="menu" 
							[matchModeOptions]="timeframeFilterOptions" [showOperator]="false" [maxConstraints]="1" [pTooltip]="timeframeFilterTooltip">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<!-- *** The default filterCallback is not used as we are doing our own server-side filtering *** -->
								<p-calendar [(ngModel)]="timeframeFilterDate"></p-calendar>
							</ng-template>
						</p-columnFilter>
					</div>
				</th>

				<th *ngIf="!sortMode" class="timeframe">
					Timeframe
				</th>
				
                <th class="turnover" [title]="turnoverTooltip">
					<p-checkbox [binary]="true" [(ngModel)]="turnoverFilter" (ngModelChange)="onTurnoverFilterChanged($event)"></p-checkbox>
				</th>

				<!-- When everything in the view hierarchy is an angular component, this type of dynamic column logic is probably best
				handled with content projection. While AJS is still in the mix, I have found this to be a working and clean approach. -->
				<ng-container *ngFor="let column of columnKeys" [ngSwitch]="column.field">
					<ng-container *ngSwitchCase="'note'">
						<th *ngIf="column.show" class="note-table-note">{{column.header}}</th>
					</ng-container>

					<ng-container *ngSwitchCase="'createdBy'">
						<th *ngIf="column.show && sortMode" class="full-name" pSortableColumn="createdBy">
							{{column.header}}
							<p-sortIcon field="createdBy" [pTooltip]="sortIconTooltips.createdBy"></p-sortIcon>
						</th>

						<th *ngIf="column.show && !sortMode" class="full-name">
							{{column.header}}
						</th>
					</ng-container>

					<ng-container *ngSwitchCase="'updatedBy'">
						<th *ngIf="column.show && sortMode" class="full-name" pSortableColumn="updatedBy">
							{{column.header}}
							<p-sortIcon field="updatedBy" [pTooltip]="sortIconTooltips.updatedBy"></p-sortIcon>
						</th>

						<th *ngIf="column.show && !sortMode" class="full-name">
							{{column.header}}
						</th>
					</ng-container>

					<ng-container *ngSwitchCase="'updated'">
						<th *ngIf="column.show" class="date">
							{{column.header}}
						</th>
					</ng-container>

					<ng-container *ngSwitchCase="'tags'">
						<th *ngIf="column.show" class="tags">
							{{column.header}}
						</th>
					</ng-container>

					<ng-container *ngSwitchCase="'acknowledgments'">
						<th *ngIf="column.show" class="acknowledgments">{{column.header}}</th>
					</ng-container>

					<ng-container *ngSwitchCase="'priority'">
						<th *ngIf="column.show && sortMode" pSortableColumn="maxPriority" class="priority">
							<div class="p-d-flex p-ai-center">
								{{column.header}}
								<p-sortIcon field="maxPriority" [pTooltip]="sortIconTooltips.maxPriority"></p-sortIcon>
								<!-- Commented out till server bug with maxPriority parameter is resolved -->
								<!-- <p-columnFilter type="numeric" field="maxPriority" display="menu" class="p-ml-auto"></p-columnFilter> -->
							</div>
						</th>

						<th *ngIf="column.show && !sortMode" class="priority">
							{{column.header}}
						</th>
					</ng-container>
				</ng-container>    
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-note let-index="rowIndex">
			<tr #tr class="mobile-card-row" *ngIf="showVerticalView" (mouseenter)="displayNoteActions[note.id] = true" (mouseleave)="displayNoteActions[note.id] = false">
				<p-card styleClass="mobile-card p-shadow-3">
					<div class="mobile-card-container">
						<div class="nsi-container">
							<nsi-indicator [note]="note" type="Updated"></nsi-indicator>
							<nsi-indicator [note]="note" type="CarryForward"></nsi-indicator>
						</div>

						<div>
							<div class="p-grid p-nogutter">
								<div class="p-col">
									<div>
										<a href="#/note-detail?note={{note._links.self.href}}&log={{note.logId}}"
										   (click)="onNoteTimeClicked(index, note, $event)">
											{{(note.noteTime | date:'MM/dd/yyyy HH:mm')}}
										</a>

										<span *ngIf="note.carryForward" title="Carry Forward">
											<i class="fa fa-clock-o" title="Carry Forward"></i>

											<br>

											<span *ngIf="note.carryForwardEndTime" class="w-100">
												{{noteCarryForwardEnded(note) ? 'Ended ' : 'To '}}
												{{(note.carryForwardEndTime | date: 'MM/dd/yyyy HH:mm')}}
											</span>
										</span>
									</div>

									<div *ngIf="showPriorityColumn">
										<span>Priority: {{note.maxPriority}}</span>
									</div>

									<div *ngIf="note.attachments.length">
										<p-overlayPanel #fal appendTo="body">
											<ng-template pTemplate>
												<lb-file-attachment-list [fileAttachments]="note.attachments" [responsiveSize]="400"></lb-file-attachment-list>
											</ng-template>
										</p-overlayPanel>

										<button pButton pRipple (click)="fal.toggle($event)" label="Attachments" icon="pi pi-paperclip"
												class="p-button-rounded p-button-secondary p-button-text attachment-btn">
										</button>
									</div>
								</div>

								<div class="p-col text-right">
									<span *ngIf="showCreatedByColumn">
										{{note[verticalViewNameField].firstName}} {{note[verticalViewNameField].lastName}}
									</span>

									<div>
										Turnover:
										<p-checkbox [formControl]="getTurnoverControl(note)"
													(onChange)="toggleTurnover(note)"
													[binary]="true">
										</p-checkbox>
									</div>
								</div>
							</div>

							<div>
								<lb-note [note]="note" [showExpander]="true" [parentTable]="containerElement" [parentTableRow]="tr"></lb-note>
							</div>

							<div *ngIf="showNoteActions(note.id)">
								<div class="p-mt-1">
									<lb-note-actions [actions]="noteActions" [note]="note" [completion]="noteActionEvent"></lb-note-actions>
								</div>
							</div>

							<div *ngIf="note.noteComments.length" class="note-comment">
								<p-divider></p-divider>

								<label>Comments</label>

								<ng-container *ngFor="let comment of note.noteComments; let i = index">
									<!-- commentsToShow === 0 means show unlimited comments  -->
									<div *ngIf="showingComments[note.id] || note.commentsToShow === 0 || i < note.commentsToShow">
										<span>{{comment.updated | date: 'MM/dd/yyyy HH:mm'}} - {{comment.updatedBy.firstName}} {{comment.updatedBy.lastName}}</span>
										<span>{{comment.comment}}</span>
									</div>
								</ng-container>

								<button *ngIf="note.commentsToShow !== 0 && note.noteComments.length > note.commentsToShow"
									pButton class="p-button-link p-p-0"
									label="{{showingComments[note.id] ? 'Show fewer comments' : 'Show ' + (note.noteComments.length - note.commentsToShow) + ' more comment' + (((note.noteComments.length - note.commentsToShow) != 1) ? 's' : '')}}"
									(click)="showingComments[note.id] = !showingComments[note.id]">
								</button>
							</div>

							<div *ngIf="showUpdatedByColumn || showUpdatedColumn">
								<p-divider></p-divider>

								<div class="p-grid p-nogutter">
									<div *ngIf="showUpdatedColumn" class="p-col">
										<label>Updated</label>

										<div>{{note.updated | date:'MM/dd/yyyy HH:mm'}}</div>
									</div>

									<div *ngIf="showUpdatedByColumn" class="p-col">
										<label>Updated By</label>

										<div>{{note.updatedBy.firstName}} {{note.updatedBy.lastName}}</div>
									</div>
								</div>
							</div>

							<div *ngIf="showTagsColumn">
								<p-divider></p-divider>

								<label>Tags</label>

								<div>{{note.tagsDisplayString}}</div>
							</div>

							<div *ngIf="showAcknowledgmentsColumn">
								<p-divider></p-divider>

								<label>Acknowledgements</label>

								<div *ngIf="showAcknowledgmentsColumn">
									<note-acknowledgements [showTime]="true" [note]="note" [showAll]="showAllAcks"></note-acknowledgements>
								</div>
							</div>
						</div>
					</div>
				</p-card>
			</tr>

			<tr #tr class="notes-table-row" *ngIf="!showVerticalView" (mouseenter)="displayNoteActions[note.id] = true" (mouseleave)="displayNoteActions[note.id] = false">
                <td class="timeframe">
					<div>
						<div class="nsi-container">
							<nsi-indicator [note]="note" type="Updated"></nsi-indicator>
							<nsi-indicator [note]="note" type="CarryForward"></nsi-indicator>
						</div>

						<div class="sticky-container">
							<div class="p-grid p-nogutter">
								<div class="p-col">
									<a href="#/note-detail?note={{note._links.self.href}}&log={{note.logId}}"
									   (click)="onNoteTimeClicked(index, note, $event)">
										{{(note.noteTime | date:'MM/dd/yyyy HH:mm')}}
									</a>

									<span *ngIf="note.carryForward" title="Carry Forward">
										<i class="fa fa-clock-o" title="Carry Forward"></i>

										<br>

										<span *ngIf="note.carryForwardEndTime" class="w-100">
											{{noteCarryForwardEnded(note) ? 'Ended ' : 'To '}}
											{{(note.carryForwardEndTime | date: 'MM/dd/yyyy HH:mm')}}
										</span>
									</span>
									<div>
										<button *ngIf="note.attachments.length" pButton pRipple (click)="fal.toggle($event)" icon="pi pi-paperclip"
												class="p-button-rounded p-button-secondary p-button-text attachment-btn">
										</button>
									</div>
								</div>
							</div>

							<p-overlayPanel #fal appendTo="body">
								<ng-template pTemplate>
									<lb-file-attachment-list [fileAttachments]="note.attachments" [responsiveSize]="400"></lb-file-attachment-list>
								</ng-template>
							</p-overlayPanel>
						</div>
					</div>
				</td>
				
                <td class="turnover">
					<div class="sticky-container">
						<div>
							<p-checkbox [formControl]="getTurnoverControl(note)" (onChange)="toggleTurnover(note)" [binary]="true"></p-checkbox>
						</div>
					</div>
				</td>

				<ng-container *ngFor="let column of columnKeys" [ngSwitch]="column.field">
					<ng-container *ngSwitchCase="'note'">
						<td *ngIf="column.show">
							<lb-note [note]="note" [showExpander]="true" [parentTable]="containerElement" [parentTableRow]="tr"></lb-note>

							<div *ngIf="showNoteActions(note.id)" [ngClass]="{'sticky-footer': noteActionsSticky(note.id)}" class="p-mt-1">
								<p-card class="note-action-card">
									<lb-note-actions [actions]="noteActions" [note]="note" [completion]="noteActionEvent"></lb-note-actions>
								</p-card>
							</div>

							<p-card *ngIf="note.noteComments.length" styleClass="note-comment">
								<ng-container *ngFor="let comment of note.noteComments; let i = index">
									<!-- commentsToShow === 0 means show unlimited comments  -->
									<div *ngIf="comment.id && (showingComments[note.id] || note.commentsToShow === 0 || i < note.commentsToShow)">
										<span>{{comment.updated | date: 'MM/dd/yyyy HH:mm'}} - {{comment.updatedBy.firstName}} {{comment.updatedBy.lastName}}</span>
										<span>{{comment.comment}}</span>
									</div>
								</ng-container>

								<button *ngIf="note.commentsToShow !== 0 && note.noteComments.length > note.commentsToShow"
										pButton class="p-button-link p-p-0"
										label="{{showingComments[note.id] ? 'Show fewer comments' : 'Show ' + (note.noteComments.length - note.commentsToShow) + ' more comment' + (((note.noteComments.length - note.commentsToShow) != 1) ? 's' : '')}}"
										(click)="showingComments[note.id] = !showingComments[note.id]">
								</button>
							</p-card>
						</td>
					</ng-container>

					<ng-container *ngSwitchCase="'createdBy'">
						<td *ngIf="column.show" class="full-name">
							<div class="sticky-container">
								<div>{{note.createdBy.firstName}} {{note.createdBy.lastName}}</div>
							</div>
						</td>
					</ng-container>

					<ng-container *ngSwitchCase="'updatedBy'">
						<td *ngIf="column.show" class="full-name">
							<div class="sticky-container">
								<div>{{note.updatedBy.firstName}} {{note.updatedBy.lastName}}</div>
							</div>
						</td>
					</ng-container>

					<ng-container *ngSwitchCase="'updated'">
						<td *ngIf="column.show" class="date">
							<div class="sticky-container">
								<div>{{note.updated | date:'MM/dd/yyyy HH:mm'}}</div>
							</div>
						</td>
					</ng-container>

					<ng-container *ngSwitchCase="'tags'">
						<td *ngIf="column.show" class="tags">
							<div class="sticky-container">
								<div>{{note.tagsDisplayString}}</div>
							</div>
						</td>
					</ng-container>

					<ng-container *ngSwitchCase="'acknowledgments'">
						<td *ngIf="column.show" class="acknowledgments">
							<div class="sticky-container">
								<div>
									<note-acknowledgements [showTime]="true" [note]="note" [showAll]="showAllAcks"></note-acknowledgements>
								</div>
							</div>
						</td>
					</ng-container>
					
					<ng-container *ngSwitchCase="'priority'">
						<td *ngIf="column.show" class="priority">
							<div class="sticky-container">
								<div>{{note.maxPriority}}</div>
							</div>
						</td>
					</ng-container>
				</ng-container>
            </tr>
        </ng-template>
    </p-table>
</div>